

























































































































import Vue from "vue";
import Component from "vue-class-component";
import { State } from "vuex-class";
import UserGroup from "@/modules/user/model/UserGroup";
import AppRelease from "@/modules/app-router/model/AppRelease";
import { Prop, Ref, Watch } from "vue-property-decorator";
import ApiVersionSelect from "@/modules/app-router/components/ApiVersion/ApiVersionSelect.vue";
/* import AppReleaseSelect from '@/modules/app-router/components/AppRelease/AppReleaseSelect.vue' */
import App from "@/modules/app-router/model/App";
import { loadModule } from "@/store";
import { MutationTypes } from "@/modules/app-router/store/mutations";
import GroupReleaseAssignation from "../../model/GroupReleaseAssignation";
import * as api from "@/modules/app-router/api";
import User from "@/modules/user/model/User";
import UserPlaform from "../../model/UserPlaform";
import UserPlaformStatusChange from "../../model/UserPlaformStatusChange";
import _ from "lodash";
//import UserAttributes from '@/modules/user/components/UserAttributes.vue';
// import { method } from "lodash";
import ApiVersion from "../../model/ApiVersion";
import { Colors, notify } from "@/modules/core/notification";
import RegisterPlatformUser from "@/modules/app-router/components/Unigest/RegisterPlatformUser.vue";
import Loader from "@/components/Loader.vue";
import { sleep } from "@/modules/user/store/actions";
/**
 * Widget cargado en la pantalla de usuario para mostrar información sobre el grupo
 */
@Component({
  components: { Loader, ApiVersionSelect, RegisterPlatformUser },
})
export default class UserPlatformWidget extends Vue {
  /**
   * Controla la visibilidad del estado
   */
  @Prop({ type: Boolean, default: false })
  public value: boolean;

  /**
   * Usuario
   */
  @State((state) => state.user.currentUser)
  public user: User;
  /**
   * Grupo de usuarios seleccionado
   */
  @State((state) => state.user.userGroup)
  public group: UserGroup;
  public busyTitle = "Procesando en plataforma...";
  public loading = true;
  public loadingLock = false;
  public loadingConfirmed = false;
  public userPlaform: UserPlaform = new UserPlaform();
  public serialNumber = "";
  public deleteUserPlaformConfirm = false;
  public deletingUser = false;
  public isDeleteFromBBDDUnigest = true;
  public apiCurrent: ApiVersion = new ApiVersion(); //AppRelease = new AppRelease()
  public apiURL = "";
  public serialCurrent = "";
  public stateRegistre = "Sin registrar";
  // public isRegisteredOnPlatform = false;
  public unigestDialog = false;
  private unsubscribeDeleteUser: any;
  private nameTaksDeleteUserPlaforn =
    "TaksDeleteUserPlaforn" + new Date().getTime();

  /**
   * Al crear el componente carga la lista de asignaciones
   */
  public async created() {
    this.$emit("loading", (this.busy = true));
    this.setSeriealGroup();
    const result = await this.getDataUserPlaform(
      this.user.id,
      this.getIdApiCurrent()
    );

    this.unsubscribeDeleteUser = this.$store.subscribeAction(
      async (action, state) => {
        if (action.type === "user/saveUser") {
          setTimeout(() => {
            this.setSeriealGroup();
            this.getDataUserPlaform(this.user.id, this.getIdApiCurrent());
          }, 300);
        }
      }
    );

    this.$store.commit("user/SET_TASK_BEFORE_DELETE_USER", {
      name: this.nameTaksDeleteUserPlaforn,
      task: this.taskDeletePlatformUser,
    });
    this.$emit("loading", (this.busy = false));
  }

  public beforeDestroy() {
    // desuscripbirse de la accion user/deleteUser
    if (this.unsubscribeDeleteUser) {
      this.unsubscribeDeleteUser();
    }
    // borrar tarea
    this.$store.commit("user/DELETE_TASK_BEFORE_DELETE_USER", {
      name: this.nameTaksDeleteUserPlaforn,
    });
  }

  /**
   * Actualiza un campo de del grupo actualmente seleccionado
   *
   * @param field
   * @param value
   */
  public updateFieldUser(field: string, value: any) {
    //this.$store.commit("user/UPDATE_USER_GROUP_FIELD", { field, value });
    this.$store.commit("user/UPDATE_USER_FIELD", { field, value });
  }

  private async getUserPlaform(idUser: number, idApi: number) {
    try {
      this.$emit("loading", (this.busy = true)); //this.loading = true
      return await api.getPlatformUser(idUser, idApi);
    } catch (e) {
      throw new Error(_.get(e, "response.data.message", e.message));
    } finally {
      this.$emit("loading", (this.busy = false)); //this.loading = false
    }
  }
  public onDeletePlatformUser() {
    this.deletingUser = true;
    this.deleteUserPlatform();
    this.deleteUserPlaformConfirm = false;
    this.deletingUser = false;
  }

  public taskDeletePlatformUser = async () => {
    if (!this.$store.state.user.checkingiDeleteFromBBDDUnigest) {
      return;
    }
    this.isDeleteFromBBDDUnigest = true;
    const data = this.dataToUserPlaformDelete();
    data.borradoTotal = true;
    const result = await api.ChangeUserStatusPlatform(data);
    await sleep(100);
  };

  private async changeUserStatusPlatform() {
    if (this.busy) return;
    try {
      this.$emit("loading", (this.busy = true)); //this.loading = true
      const data = this.dataToUserPlaformStatusChange();
      const result = await api.ChangeUserStatusPlatform(data);
      const ru = await this.getDataUserPlaform(
        this.user.id,
        this.getIdApiCurrent()
      );
      if (result && result.result) {
        //notify(`El usuario ${this.user.id} ha cambiado de estado correctamente.`, Colors.Success)
        notify(result.result, Colors.Success);
      }
      return result;
    } catch (e) {
      // Si hay un error
      this.entityToData();
      throw new Error(_.get(e, "response.data.message", e.message));
    } finally {
      this.$emit("loading", (this.busy = false)); //this.loading = false
      this.loadingConfirmed = false;
      this.loadingLock = false;
    }
  }

  public async refresh() {
    try {
      this.$emit("loading", (this.busy = true)); //this.loading = true
      this.getDataUserPlaform(this.user.id, this.getIdApiCurrent());
      this.showNotifyError();
    } catch (e) {
      // Si hay un error
      this.entityToData();
      throw new Error(_.get(e, "response.data.message", e.message));
    } finally {
      this.$emit("loading", (this.busy = false)); //this.loading = false
      this.loadingConfirmed = false;
      this.loadingLock = false;
    }
  }

  private entityToData() {
    this.stateRegistre = "No registrado";
    if (
      this.userPlaform.advertencias &&
      this.userPlaform.advertencias.length > 0
    ) {
      this.stateRegistre = this.userPlaform.advertencias.toString();
      notify(this.stateRegistre, Colors.Warning);
    } else if (
      this.userPlaform.errores &&
      this.userPlaform.errores.length > 0
    ) {
      this.stateRegistre = this.userPlaform.errores.toString();
      notify(this.stateRegistre, Colors.Error);
    } else if (this.userPlaform.found) {
      // si usuario encontrado en unigest server es que está registrado.
      this.stateRegistre = `Registrado`;
    }

    this.serialNumber = this.userPlaform.numeroDeSerie;
    this.apiURL = this.userPlaform.apiUnigest;
  }

  private dataToUserPlaformStatusChange(): UserPlaformStatusChange {
    const data = new UserPlaformStatusChange();
    data.id = this.user.id;
    data.serialOrEmail = this.user.email;
    data.scopeAffected = 1; // ambito solo usuario
    data.apiUrl = this.apiURL; //this.getUriApiServiceUnigest //this.user.attributes.apiURL.toString()
    return data;
  }

  private dataToUserPlaformDelete(): UserPlaformStatusChange {
    const data = new UserPlaformStatusChange();
    data.id = this.user.id;
    data.serialOrEmail = this.user.email;
    data.scopeAffected = 1; // ambito solo usuario
    data.userStatus = 2; // Borrado de la plataforma
    data.borradoTotal = this.isDeleteFromBBDDUnigest;
    data.apiUrl = this.apiURL; //this.getUriApiServiceUnigest // this.user.attributes.apiURL.toString()
    return data;
  }

  private async getDataUserPlaform(idUser: number, idApi: number) {
    if (idUser < 1 || this.serialCurrent.length === 0) {
      //this.isRegisteredOnPlatform = false;
      return;
    }
    this.userPlaform = await this.getUserPlaform(idUser, idApi);
    this.entityToData();

    // this.isRegisteredOnPlatform = this.userPlaform.found;
  }

  private async deleteUserPlatform() {
    if (this.busy) return;
    let result: any;
    try {
      this.$emit("loading", (this.busy = true)); //this.loading = true
      result = await this.ChangeUserStatusPlatformForDelete();
      const resultU = await this.getDataUserPlaform(
        this.user.id,
        this.getIdApiCurrent()
      );
      return result;
    } catch (e) {
      // Si hay un error
      throw new Error(_.get(e, "response.data.message", e.message));
    } finally {
      this.entityToData();
      const msg = result && result.result ? result.result : "";
      if (msg && msg.length > 0) {
        notify(msg, Colors.Success);
      }

      this.$emit("loading", (this.busy = false)); //this.loading = false
      this.loadingConfirmed = false;
      this.loadingLock = false;
    }
  }

  private async ChangeUserStatusPlatformForDelete() {
    const data = this.dataToUserPlaformDelete();
    return await api.ChangeUserStatusPlatform(data);
  }

  /* private async loadModuleAppRouter() {
    // cargar el modulo appRouter
    await loadModule("appRouter");

    // Carga la lista de usuarios
    await this.$store.dispatch("appRouter/loadApps");
    await this.$store.dispatch("appRouter/loadApis");

    // Obener la aplicacion (Unigest.net)
    const selectedApp = JSON.parse(
      localStorage.getItem("appRouter.selectedApp") || "null"
    );
    if (!selectedApp) {
      return;
    }

    await this.$store.dispatch("appRouter/loadApp", selectedApp);

    const api = this.$store.state.appRouter.apis[0];
    if (!api) {
      return;
    }
    this.$store.commit("appRouter/SET_CURRENT_API", api);
    // Cargar la versiones
    await this.$store.dispatch("appRouter/loadGroupReleaseAssignations");
  }
 */
  public getIdApiCurrent(): number {
    let result = 0;
    const id = parseInt(_.get(this.apiCurrent, "apiVersion.id", 0).toString());
    if (!id && id > 0) {
      result = id;
    }
    return result;
  }

  public get isDisabled(): boolean {
    return (
      this.busy ||
      // !this.isRegisteredOnPlatform ||
      !this.userPlaform ||
      this.userPlaform.email === null ||
      this.userPlaform.email.length === 0 ||
      !this.userPlaform.found
    );
  }

  private setSeriealGroup() {
    this.serialCurrent = "";
    if (
      this.user.groups.length > 0 &&
      this.user.groups[0].attributes &&
      this.user.groups[0].attributes.SERIAL_NUMBER
    ) {
      this.serialCurrent = this.user.groups[0].attributes.SERIAL_NUMBER || "";
    }
  }

  private showNotifyError() {
    if (!this.userPlaform || this.userPlaform.email.length === 0) {
      notify(
        `El usuario ${this.user.id} no se ha encontrado en la plataforma.`,
        Colors.Warning
      );
      /*  } else {
            notify(`El usuario ${this.user.id} ha cambiado de estado correctamente.`, Colors.Success) */
    }
  }

  /// REGISTAR USARIO

  onShowDialogoRegisterPlatformUser() {
    if (this.user.isNew) {
      throw new Error(
        "Debe de guardar los cambios antes de registrar usuario en la plataforma Unigest.net"
      );
      return;
    }

    let serial = this.getSerialUnigest;

    if (serial === undefined || serial.length <= 4) {
      throw new Error("Debe de asingar un numero serie al usuario.");
      return;
    }
    this.unigestDialog = true;
  }

  onRegisterPlatformUserClosed(tipo: number) {
    if (tipo === 1) {
      this.unigestDialog = false;
    } else if (tipo === 2 || tipo === 3) {
    } else {
      this.unigestDialog = false;
    }

    if (tipo === 1 || tipo === 2 || tipo === 3) {
      this.refresh();
    }
  }

  public get isCanRegisterPlatformUser() {
    return !this.user.isNew;
  }
  public get stateRegister(): boolean {
    return this.userPlaform &&
      this.userPlaform.email &&
      this.userPlaform.email !== "" &&
      this.userPlaform.found
      ? true
      : false;
  }
  public get isShowButtonRegister() {
    return this.isCanRegisterPlatformUser && !this.stateRegister;
  }
  private get busy(): boolean {
    return this.loading;
  }
  private set busy(value: boolean) {
    this.loading = value;
  }
  // Devuelve el nº de serie
  private get getSerialUnigest() {
    let serial = "";
    if (this.user && this.user.groups && this.user.groups.length > 0) {
      serial = this.user.groups[0].attributes.SERIAL_NUMBER;
    }
    return serial;
  }

  public get serverSQLUserGrup(): string {
    return (this.user &&
      this.user.groups && 
      this.user.groups.length > 0 &&
      this.user.groups[0] &&
      this.user.groups[0].attributes.SERVER_SQL)
      ? this.user.groups[0].attributes.SERVER_SQL
      : "";
  }
}
